<template>
  <div class="block block-fx-shadow block-rounded block-themed">
    <div class="block-header bg-gd-emerald border-b ">
        <h1 class="block-title">{{ $t('payments.index') }}</h1>
    </div>
    <div class="table-responsive">
      <table class="table table-borderless table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t('debtors.fullname') }} должника</th>
            <th>{{ $t('debts.number') }}</th>
            <th>{{ $t('payments.amount') }}</th>
            <th>{{ $t('payments.payment_date') }}</th>
            <th>{{ $t('options.status') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="!loader">
            <tr v-for="(payment, index) in payments" :key="index">
              <td>{{++index}}</td>
              <td>{{payment.debt.debtor.fullname}}</td>
              <td>{{payment.debt.number}}</td>
              <td>{{payment.amount}}</td>
              <td>{{payment.payment_date | dateFormat}}</td>
              <td>{{payment.confirmed ? $t('payments.confirmed') : $t('payments.not_confirmed') }}</td>
            </tr>
          </template>
          <tr v-if="loader">
            <td colspan="3" class="text-center">
              <loader-wave/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loader: false,
      payments: [],
    }
  },
  mounted() {
    this.loader = true;
    this.getPayments();
  },
  methods: {
    async getPayments() {
      const { data } = await window.axios.get('/users/payments');
      this.payments = data.payments;
      console.log(this.payments);
      this.loader = false;
    }
  }
}
</script>
